'use strict';

var _ = require('lodash');
var ConfigurationUserDefinedRefDataController = function ConfigurationUserDefinedRefDataController($rootScope, $scope, searchCriteriaMatcherService, configurationUserReferenceDataDTDRenderersFactory, dataRetrieverService, dataRetrieverConstantsService, gridStatusCustomRenderersFactory, urdConstants, marketDropdownValues, flightDropdownValues, configurationUserDefinedRefDataGridToolbarFunctionsService) {
  dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.SYSTEM_STATUS_SCREEN, dataRetrieverConstantsService.SYSTEM_STATUS_CONFIGURATION_USER_DEFINED_REF_DATA_FLIGHT_MODE).localSortApplied().setCustomSearchCriteriaRules([]);
  dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.SYSTEM_STATUS_SCREEN, dataRetrieverConstantsService.SYSTEM_STATUS_CONFIGURATION_USER_DEFINED_REF_DATA_MARKET_MODE).localSortApplied().setCustomSearchCriteriaRules([]);
  $scope.customRenderers = _.assign({}, configurationUserReferenceDataDTDRenderersFactory, gridStatusCustomRenderersFactory);
  $scope.configurationStatusEventName = 'configuration-urd-status';
  $scope.HEP_TYPE = urdConstants.HEP_TYPE;
  $scope.VIEW = {
    FLIGHT: 'flight',
    MARKET: 'market'
  };
  $scope.views = [{
    label: 'Market',
    value: $scope.VIEW.MARKET,
    screenKey: 'SYSTEM_CONFIGURATION_USER_DEFINED_REF_DATA_MARKET'
  }, {
    label: 'Flight',
    value: $scope.VIEW.FLIGHT,
    screenKey: 'SYSTEM_CONFIGURATION_USER_DEFINED_REF_DATA_FLIGHT'
  }];
  $scope.selectedView = $scope.VIEW.MARKET;
  $scope.dataReadyForGrid = function () {
    return true;
  };
  $scope.$watch('selectedView', function () {
    var screenKey = _.find($scope.views, {
      value: $scope.selectedView
    }).screenKey;
    if ($scope.selectedView === $scope.VIEW.FLIGHT) {
      flightDropdownValues.updateData();
      searchCriteriaMatcherService.setFieldsMap({
        'Airline': 'airline',
        'Flight Entity': 'flightEntity',
        'Leg': 'flightLeg',
        'Flight Number': 'flightNumber'
      });
    }
    if ($scope.selectedView === $scope.VIEW.MARKET) {
      marketDropdownValues.updateData();
      searchCriteriaMatcherService.setFieldsMap({
        'Market': 'market',
        'Market Entity': 'marketEntity'
      });
    }
    $rootScope.$broadcast('user-ref-data:view-changed', screenKey);
  });
  $scope.$on('search-criteria:searchChangeEvent', function () {
    searchCriteriaMatcherService.refreshSearchCriteria();
  });
  function updateStatus(rowId, newValue, oldValue) {
    var setCellValueParams = {
      rowId: rowId,
      columnName: 'status',
      newValue: newValue,
      oldValue: oldValue,
      gridId: undefined,
      refreshOnly: true
    };
    $scope.$broadcast('grid:setCellValue', setCellValueParams);
  }
  function isDtdFunctionEmpty(dtd) {
    return _.every(['MIN', 'MAX', 'AVG'], function (v) {
      return _.isUndefined(dtd[v]) || _.isString(dtd[v]) && _.isEmpty(dtd[v]);
    });
  }
  $scope.canToggleStatus = function (type, modalData, value) {
    var isEmpty = isDtdFunctionEmpty(value[0]);
    var isValid = !configurationUserDefinedRefDataGridToolbarFunctionsService.validateRowAttributes(type, modalData) && !configurationUserDefinedRefDataGridToolbarFunctionsService.validateDtds(value);
    return !isEmpty && isValid;
  };
  $scope.toggleStatusBasedOnDtds = function (rowId, value) {
    var isEmpty = isDtdFunctionEmpty(value[0]);
    updateStatus(rowId, isEmpty ? 'DISABLED' : 'ACTIVE');
  };
  $scope.changeStatusHandler = function (event, data, newStatus) {
    updateStatus(data.uid, newStatus, data.status);
  };
};
ConfigurationUserDefinedRefDataController.$inject = ['$rootScope', '$scope', 'DropdownValuesSearchCriteriaMatcherService', 'ConfigurationUserReferenceDataDTDRenderersFactory', 'DataRetrieverService', 'DataRetrieverConstantsService', 'GridStatusCustomRenderersFactory', 'UrdConstants', 'MarketDropdownValuesService', 'FlightDropdownValuesService', 'ConfigurationUserDefinedRefDataGridToolbarFunctionsService'];
module.exports = ConfigurationUserDefinedRefDataController;